import Vue from 'vue'
import VueRouter from 'vue-router'
// Client
import Performance from '@/components/Performance'
import Home from '@/components/home/Home'

var beforeEnter = (to, from, next) => {
  if (!router.app.$session.has('user')) {
    next({path: '/login'})
  } else {
    if (router.app.$session.get('user').admin) {
      next()
    } else {
      if (router.app.$session.get('user').transaction) {
        next({path: '/output'})
      } else {
        next({path: '/output-educational'})
      }
    }
  }
  next()
}
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      name: '',
      path: '/',
      beforeEnter: (to, from, next) => {
        if (router.app.$session.has('user')) {
          if (router.app.$session.get('user').admin) {
            next({path: '/home'})
          } else {
            if (router.app.$session.get('user').transaction) {
              next({path: '/output'})
            } else {
              next({path: '/output-educational'})
            }
          }
        } else {
          next({path: '/login'})
        }
        next()
      }
    },
    {
      name: 'login',
      path: '/login',
      beforeEnter: (to, from, next) => {
        if (router.app.$session.has('user')) {
          if (router.app.$session.get('user').admin) {
            next({path: '/home'})
          } else {
            if (router.app.$session.get('user').transaction) {
              next({path: '/output'})
            } else {
              next({path: '/output-educational'})
            }
          }
        } else {
          next()
        }
        next()
      },
      props: {theme: 'login'},
      component: Performance,
      meta: {
        title: 'Iniciar Sesión'
      }
    },
    {
      name: 'signup',
      path: '/signup',
      props: {theme: 'signup'},
      component: Performance,
      meta: {
        title: 'Registrate'
      }
    },
    {
      name: 'recovery-password',
      path: '/recovery-password',
      props: {theme: 'recovery-password'},
      component: Performance,
      meta: {
        title: 'Recupera tu Contraseña'
      }
    },
    {
      name: 'logout',
      path: '/logout',
      beforeEnter: (to, from, next) => {
        router.app.$session.destroy()
        next({path: '/login'})
        // next()
      }
    },
    {
      name: 'index',
      path: '/',
      component: Performance
    },
    {
      name: 'home',
      path: '/home',
      component: Home,
      props: {view: 'dashboard-view'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'account',
      path: '/account',
      component: Home,
      props: {view: 'accounts-view'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'account-new',
      path: '/account/new',
      component: Home,
      props: {view: 'account-form'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'account-edit',
      path: '/account/:id',
      component: Home,
      props: {view: 'account-form'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'input',
      path: '/input',
      component: Home,
      props: {view: 'input-view'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'input-students',
      path: '/input-students',
      component: Home,
      props: {view: 'input-students-view'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'output',
      path: '/output',
      component: Home,
      props: {view: 'output-view'},
      beforeEnter: (to, from, next) => {
        if (!router.app.$session.get('user').admin && !router.app.$session.get('user').transaction && router.app.$session.get('user').transactionEducational) {
          next({path: '/home'})
        }
        next()
      },
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'output-excel',
      path: '/output/excel',
      component: Home,
      props: {view: 'output-excel'},
      beforeEnter: (to, from, next) => {
        if (!router.app.$session.get('user').admin) {
          next({path: '/home'})
        }
        next()
      },
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'output-educational',
      path: '/output-educational',
      component: Home,
      props: {view: 'output-educational-view'},
      beforeEnter: (to, from, next) => {
        if (!router.app.$session.get('user').admin && !router.app.$session.get('user').transactionEducational && router.app.$session.get('user').transaction) {
          next({path: '/home'})
        }
        next()
      },
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'user',
      path: '/user',
      component: Home,
      props: {view: 'users-view'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'user-new',
      path: '/user/new',
      component: Home,
      props: {view: 'user-form'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'user-edit',
      path: '/user/:id',
      component: Home,
      props: {view: 'user-form'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    },
    {
      name: 'change-password',
      path: '/changepassword',
      component: Home,
      props: {view: 'password-view'},
      beforeEnter,
      meta: {
        title: 'SIH'
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js